import { useAppKitAccount } from '@reown/appkit/react';
import { useEffect } from 'react';

import { WALLET_CACHE_TAGS } from 'modules/common/constants/cache-tags';
import { cryptoApi } from 'store/queries/cryptoApi';
import { useAppDispatch } from 'store/useAppDispatch';

/**
 * This is the complete listener for the crypto wallet.
 *
 * If you need to add something, please consider to create a new listener.
 */
export const CryptoWalletListener = () => {
  const dispatch = useAppDispatch();
  const { address, isConnected } = useAppKitAccount();

  useEffect(() => {
    if (isConnected && address) {
      dispatch(cryptoApi.util.invalidateTags([WALLET_CACHE_TAGS.account]));
    }
  }, [isConnected, address, dispatch]);

  return null;
};
